import React, { useState } from "react";
import { Grid, IconButton, Tooltip, Typography, Divider } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";

const PriceListActionMenu = ({
  isEdit,
  onSave,
  onDelete,
  onClear,
  onExit,
  saveDisabled,
}) => {
  const [selectedButton, setSelectedButton] = useState(null);

  const handleClick = (btn) => {
    setSelectedButton(btn);
    if (btn === "save") onSave();
    else if (btn === "delete") onDelete();
    else if (btn === "clear") onClear();
    else if (btn === "exit") onExit();
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      padding={1}
    >
      {/* Left Title */}
      <Grid item>
        <Typography
          variant="h4"
          sx={{ marginLeft: "10px", fontSize: "1.2rem", fontWeight: 600 }}
        >
          {isEdit ? "Edit Price List Entry" : "New Price List Entry"}
        </Typography>
      </Grid>

      {/* Right Buttons */}
      <Grid item>
        <Grid container alignItems="center">

          {/* Save */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Save Price List">
              <IconButton
                onClick={() => handleClick("save")}
                sx={{ display: "flex", alignItems: "center" }}
                disabled={saveDisabled}
              >
                <SaveAltIcon
                  sx={{
                    fontSize: "18px",
                    color: selectedButton === "save" ? "yellow" : "#009688",
                  }}
                />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Save
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          {/* Delete only in Edit mode */}
          {isEdit && (
            <>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              <Grid item ml={1} mr={1}>
                <Tooltip title="Delete Price List">
                  <IconButton
                    onClick={() => handleClick("delete")}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <DeleteIcon sx={{ fontSize: "18px", color: "#d72c0d" }} />
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      Delete
                    </Typography>
                  </IconButton>
                </Tooltip>
              </Grid>
            </>
          )}

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Clear */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Clear Form">
              <IconButton
                onClick={() => handleClick("clear")}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <ClearAllIcon sx={{ fontSize: "18px", color: "#e0d620" }} />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Clear
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Exit */}
          <Tooltip title="Exit">
            <IconButton onClick={() => handleClick("exit")}>
              <CloseIcon sx={{ fontSize: "18px", color: "#2196F3" }} />
            </IconButton>
          </Tooltip>
          <Divider orientation="vertical" flexItem />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PriceListActionMenu;
